import React, { useState } from 'react';
import styled from 'styled-components';
import img1 from '../images/marble1.jpg'
import {  projectData } from './data';
import { useNavigate } from 'react-router-dom';
import Carousel from './Carousel';
const Wrapper = styled.div`
  position: relative; /* Ensures that the child can be positioned relative to this wrapper */
`;



const FloatingDiv = styled.div`
  position: absolute;
  top: 100%; /* Adjust this to move it up/down */
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%; /* Width of the form */
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  div {
    padding: 10px;
    margin: 5px;
    background-color: #f3f3f3;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }

  .active {
    background-color: #ce8e04; /* Color for selected item */
    color: white;
  }

  /* For smaller screens like tablets */
  @media (max-width: 768px) {
    width: 95%; /* Increase the width slightly on smaller screens */
    padding: 10px; /* Reduce padding for compact layout */
    flex-wrap: wrap; /* Ensure that items wrap if space is tight */

    div {
      padding: 8px;
      margin: 3px; /* Reduce margin to fit more content */
      flex: 1 1 45%; /* Allow divs to take 45% width for better fit */
    }
  }

  /* For mobile devices */
  @media (max-width: 480px) {
  top: 130%;
  border-radius:3px;
    width: 80%; /* Full width for mobile */
    padding: 13px; /* Further reduce padding */
    flex-direction: column; /* Stack divs vertically for mobile */

    div {
      padding: 6px;
      font-size: 12px; /* Make font size smaller */
      margin: 2px; /* Reduce spacing even more to fit on small screens */
      width: 100%; /* Ensure divs take full width on mobile */
      text-align: center; /* Center the content for a cleaner look */
    }
  }
`;



const Projects = () => {
  const [selectedItem, setSelectedItem] = useState('All'); // Default to "All"
  const navigate = useNavigate();

  const items = ["All", "Hospitality","Government Projects", "Hotel & Residential", "Commercial","Villas"]; // Example categories

  const handleClick = (item) => {
    setSelectedItem(item); // Set the clicked item as the selected one
  };

  // Filter the projects based on the selected category
  const filteredProjects = selectedItem === 'All' 
    ? projectData // Show all projects if "All" is selected
    : projectData.filter((project) => project.category === selectedItem); // Filter by category

  
  return (
    <div>
      <Wrapper>
        <Carousel />
        <FloatingDiv>
          {items.map((item, index) => (
            <div
              key={index}
              className={selectedItem === item ? 'active' : ''} // Highlight selected item
              onClick={() => handleClick(item)} // Handle click event
            >
              {item}
            </div>
          ))}
        </FloatingDiv>
      </Wrapper>
      <br/>
      <br/>
      <br/>

      <div className="projects">
        <div className="product-container">
          <div className="product-grid">
            {filteredProjects.map((project) => (
              <div className="product-item" key={project.id}>
                <img src={project.image} alt={project.name} />
                <div className="overlay">
                  <h2>{project.name}</h2>
                  <button onClick={() => navigate(`/Projectdetails/${project.id}`)}>
                    View Details
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <br/>

    </div>
  );
};

export default Projects;
